import api from "./api";

/**
 * 📊 Fetch dashboard summary + recent items per status bucket
 * Returns: { summary: { pending, l1_approved, l2_approved, ordered, stores, delivered }, items: {...} }
 */
export const getDashboardData = async (params = {}) => {
  try {
    const res = await api.get("/purchase-requests/dashboard/", { params });
    return res.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error?.response?.data || error;
  }
};

export const getStalePendingRequests = async (days) => {
  const res = await api.get("/purchase-requests/stale-pending/", { params: { days } });
  return res.data;
};

export const deleteStalePendingRequests = async (ids, days) => {
  const res = await api.post("/purchase-requests/delete-stale-pending/", { ids, days, confirm: "DELETE" });
  return res.data;
};
